import { IFirebaseSessionStore } from './store';

export interface ISessionData {
  clinicianId: string;
  patientId: string;
  startTime: number;
  metadata: Record<string, string>;
  activeDevices: Record<string, number>;
  isDeviceMain?: (deviceId: string) => boolean;
}

export interface ISnapshotData {
  startTime?: string;
  endTime?: number;
  metadata: Record<string, string>;
}

export enum SessionStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE_OBSERVING = 'ACTIVE_OBSERVING',
  ACTIVE_MAIN = 'ACTIVE_MAIN',
  DISCONNECTED = 'DISCONNECTED',
}
export interface ISessionState {
  status?: SessionStatus;
  sessionData: ISessionData | null;
}

export interface IFirebaseSessionLogic {
  startSession(clinicianId: string, patientId: string): void;
  endSession(): void;
  fireBaseSessionState: IFirebaseSessionStore;
}
